<template>
  <div>
    <h1 id="jump-to-header">{{heading || generated_heading}}</h1>
    <b-card bg-variant="light">
      <b-row>
        <b-col md="4">
          <product-item-show
            :id="id"
            :api_path="api_path"
            @gotAttrs="assignAttrs"
          ></product-item-show>
        </b-col>
        <b-col md="3">
          <collection-image-carousel-index
            :api_path="api_path"
            :filtering="filtering"
          ></collection-image-carousel-index>
          <b-button v-if="interest"
            @click="navigateToInterest"
            variant="success"
          >{{interestName}} INFORMATION</b-button>
        </b-col>
        <b-col md="5">
          <div v-if="showing_filtering">
            <showing-carousel-index
              :api_path="api_path"
              :filtering="showing_filtering"
            ></showing-carousel-index>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ProductItemShow from './ProductItemShow.vue'
import CollectionImageCarouselIndex from './CollectionImageCarouselIndex.vue'
import ShowingCarouselIndex from './ShowingCarouselIndex.vue'

export default {
  components: {
    ProductItemShow,
    CollectionImageCarouselIndex,
    ShowingCarouselIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      generated_heading: undefined,
      interest: undefined,
      filtering: {
        product_item_ids: this.id
      },
      showing_filtering: undefined,
      ams_template: {
        type: 'product-models',
        description: undefined,
        attributes: {
          'brand-id': this.id
        }
      },
      attrs: undefined
    }
  },
  computed: {
    interestName() {
      return this.interest ? this.interest.attributes['name'] : "Interests"
    }
  },
  methods: {
    assignAttrs(attrs, description, interest) {
      this.attrs = Object.assign( {}, attrs)
      this.showing_filtering  = {
        storage_space_path_ids: this.attrs['storage-space-id']
      }
      this.ams_template.description = description
      this.interest = interest
    },
    navigateToInterest() {
      this.$router.push( {path: '/integer_references/Interest/information/' + this.interest.id})
    },
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>